import { render, staticRenderFns } from "./faq-modal.vue?vue&type=template&id=15816de8"
import script from "./faq-modal.vue?vue&type=script&lang=js"
export * from "./faq-modal.vue?vue&type=script&lang=js"
import style0 from "./faq-modal.vue?vue&type=style&index=0&id=15816de8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports